import React, { useState } from "react";
import { useSelector } from "react-redux";

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Select,
  Row, 
  Grid
} from "./layout";

import { selectAllFoods } from "../store/selectors";
import FoodFormModal from "./forms/FoodFormModal";
import FoodImage from "./utils/FoodImage";

import defaultImage from "../assets/images/default-image.jpg";


export default function FoodOverviewGrid({ onSelectFood }) {
  const foods = useSelector(selectAllFoods);

  const [modalFood, setModalFood] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [search, setSearch] = useState("");

  const [category, setCategory] = useState("all");


  const isPickerMode = Boolean(onSelectFood);

  // const  filteredFoods = foods.filter(food => {
  //   const text = search.toLowerCase();
  //   return food.name.toLowerCase().includes(text);
  // });

  const filteredFoods = foods.filter(food => {
  const text = search.toLowerCase();

  const matchSearch =
    food.name.toLowerCase().includes(text);

  const matchCategory =
    category === "all" ||
    food.categorie?.toLowerCase() === category;

    return matchSearch && matchCategory;
  });



  const handleClickFood = (food) => {
    if (isPickerMode) {
      onSelectFood(food);
      return;
    }

    setModalFood(food);
    setModalOpen(true);
  };

  const handleAddFood = () => {
    setModalFood(null);
    setModalOpen(true);
  };

  if (!foods?.length) {
    return (
      <Content>
        <Text >No foods yet</Text>
        <Button onClick={handleAddFood}>
          Add first food
        </Button>
      </Content>
    );
  }

  return (
    <Screen>
    <Content>
    <TextInput
      placeholder="Search food..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{marginBottom:space.md}}
    />
    <Select
      value={category}
      placeholder="All categories"
      options={[
        { label: "All categories", value: "all" },
        { label: "Meat", value: "meat" },
        { label: "Fish", value: "fish" },
        { label: "Dairy", value: "dairy" },
        { label: "Vegetable", value: "vegetable" },
        { label: "Fruits", value: "fruits" },
        { label: "Grain", value: "grain" },
        { label: "Side dish", value: "side dish" },
        { label: "Drink", value: "drink" },
        { label: "Sweet", value: "sweet" },
        { label: "Vegan", value: "vegan" },
        { label: "Other", value: "other" },
      ]}
      onChange={setCategory}
      style={{marginBottom:space.md}}
    />

          {/* only show add button in library mode */}
      {!isPickerMode && (
        <Button 
        onClick={handleAddFood}
        style={{marginBottom:space.md}}
        >
          Add Food
        </Button>
      )}

      <FoodFormModal
        open={modalOpen}
        food={modalFood}
        onClose={() => setModalOpen(false)}
      />

      <Grid
        gap= "5px"
      >
        {
        filteredFoods.map((food) => (

        // foods.map((food) => (
          <Card 
            key={food.id}
            onClick={() => handleClickFood(food)}
            style={{
              width:"100px",
              padding:"0px !important"
              
            }}
          >
              {/* IMAGE */}
              {food.imageKey && (
                <FoodImage imageKey={food.imageKey} alt={food.name} />
              )}
              {!food.imageKey && (<img src={defaultImage} />)}



              <Text 
                style={{
                  fontWeight:"regular", 
                  fontSize:"10px",
                  lineHeight:"1"
                }}
              >
                <span style={{fontWeight:"bold"}}> {food.name}</span> • {food.calories} kcal
               
                {/* {food.name} {food.calories} kcal • {food.protein}p • {food.carbs}c • {food.fat}f */}
                
              </Text>

              <Text 
                style={{
                  fontWeight:"regular", 
                  fontSize:"10px",
                  lineHeight:"1"
                }}
              >
                
              </Text>

              {/* <Text 
                style={{
                  fontWeight:"regular", 
                  fontSize:"10px",
                  lineHeight:"1"
                }}
              >
                {food.categorie}
              </Text> */}

          </Card>
        ))}
      </Grid>

      {/* only show add button in library mode */}
      {/* {!isPickerMode && (
        <Button onClick={handleAddFood}>
          Add Food
        </Button>
      )}

      <FoodFormModal
        open={modalOpen}
        food={modalFood}
        onClose={() => setModalOpen(false)}
      /> */}
    </Content>
    </Screen>
  );
}
